import React from 'react'
import { getCurrentDomain } from '../../../utils/domainDetection'
import config from '../../../config/config'
import { SSOProtocol } from '../../../config/ssoTypes'
import { SSOButton } from '../SSOButton/SSOButton'
import { SAML2Button } from '../SAML2Button/SAML2Button'

interface UniversalSSOButtonProps {
  id?: string
  'data-testid'?: string
  disabled?: boolean
  className?: string
}

const UniversalSSOButton: React.FC<UniversalSSOButtonProps> = (props) => {
  const domain = getCurrentDomain()
  const domainConfig = config.getDomainSSOConfiguration(domain)

  if (domainConfig?.ssoConfig === null || domainConfig?.ssoConfig === undefined) {
    return null
  }

  switch (domainConfig.ssoConfig.protocol) {
    case SSOProtocol.OIDC:
      return <SSOButton {...props} />
    case SSOProtocol.SAML2:
      return <SAML2Button {...props} />
    default:
      return null
  }
}

export { UniversalSSOButton }

